module.exports = __webpack_public_path__ + "static/img/12.8b069b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/eng/12.png
// module id = RXjY
// module chunks = 0